// ============================================================================
// A* SEARCH - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'astar',
  name: 'A* Search',
  category: 'Graphs',
  complexity: {
    time: 'O(b^d)',
    space: 'O(b^d)'
  },
  description: 'A graph traversal and path search algorithm that uses heuristics to guide its search. It uses a best-first search strategy, evaluating nodes by combining the cost to reach the node (g) and the estimated cost to the goal (h).'
};
